import { z } from "zod";
import { ReadContentItemSchema } from "../readExcel/readExcel.schema";
export const ReadContentParamsSchema = z.object({
    uiDescription: z
        .string()
        .optional()
        .describe("Brief plain-English summary of this read request."),
    readContent: z.array(ReadContentItemSchema).describe("Read operations for worksheet ranges."),
    sessionId: z.string().optional().describe("Backend session ID (injected automatically)"),
});
export { ReadContentParamsSchema as ReadContentToolParamsSchema };
